import { render, staticRenderFns } from "./CampaignsPage.vue?vue&type=template&id=47baa99e&scoped=true&"
import script from "./CampaignsPage.vue?vue&type=script&lang=js&"
export * from "./CampaignsPage.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsPage.vue?vue&type=style&index=0&id=47baa99e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47baa99e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47baa99e')) {
      api.createRecord('47baa99e', component.options)
    } else {
      api.reload('47baa99e', component.options)
    }
    module.hot.accept("./CampaignsPage.vue?vue&type=template&id=47baa99e&scoped=true&", function () {
      api.rerender('47baa99e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CampaignsPage.vue"
export default component.exports